export const IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "svg",
];

export const WORD_EXTENSIONS = ["doc", "docx"];

export const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  svg: "image/svg+xml",
  doc: "application/msword",
  docx:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

export const DEFAULT_CONTENT_TYPE = "application/octet-stream";

export type FilePreviewKind = "pdf" | "image" | "office" | "unknown";

const FILE_KIND_BY_EXTENSION: Record<string, FilePreviewKind> = {
  pdf: "pdf",
  doc: "office",
  docx: "office",
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  webp: "image",
  bmp: "image",
  svg: "image",
};

export const getFileExtension = (name: string): string =>
  name.split(".").pop()?.toLowerCase() ?? "";

export const getContentType = (name: string): string =>
  CONTENT_TYPE_BY_EXTENSION[getFileExtension(name)] ?? DEFAULT_CONTENT_TYPE;

export const getFilePreviewKind = (name: string): FilePreviewKind =>
  FILE_KIND_BY_EXTENSION[getFileExtension(name)] ?? "unknown";
